'use client';

import { useSession } from '@shared/auth';
import { LoadingPurchasedTickets } from '../../lottery-purchases/PurchasedTickets/components/LoadingPurchasedTickets';
import { PurchasedTickets } from '../../lottery-purchases/PurchasedTickets/PurchasedTickets';
import { PurchasesLoggedOutState } from '../../lottery-purchases/PurchasesLoggedOutState/PurchasesLoggedOutState';
import type { LotteryName } from '../../lottery-purchases/types';

function PurchasesPage({ lotteries = [] }: { lotteries?: LotteryName[] }) {
  const { session } = useSession();

  if (session.status === 'uninitialised' || session.status === 'loading') {
    return <LoadingPurchasedTickets />;
  }

  return session.status === 'authenticated' ? <PurchasedTickets lotteries={lotteries} /> : <PurchasesLoggedOutState />;
}

export { PurchasesPage };
